<template>
    <footer class="app-footer">
        
        <a href="/accounts">accounts</a>
        <span class="separator">|</span>
        <a href="/logout">logout</a>
        <span class="separator">|</span>
        <a v-if="debug === 'true'" @click="setDebug" href=".">debug off</a>
        <a v-else @click="setDebug" href=".">debug</a>
        <p>&copy; 2023 Walter Company. All rights reserved.</p>
    </footer>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AppFooter',
  methods: {
    setDebug(){
      if (localStorage.getItem('debug') === 'true') {
        localStorage.setItem('debug', false)
        this.debug = false;
      }
      else {
        localStorage.setItem('debug', true)
        this.debug = true;
      }
    },
  },
  
  data() {
    return {
      debug: localStorage.getItem('debug')
    }
  }
})
</script>

<style scoped>
.app-footer {
    background-color: #f8f9fa;
    padding: 1rem;
    text-align: center;
    border-top: 1px solid #e7e7e7;
    box-shadow: 0 50vh 0 50vh #f8f9fa;
}

.app-footer p {
    margin: 0;
    color: #6c757d;
}

.app-footer .separator {
    margin: 0 0.5rem;
    color: #6c757d;
}
</style>